// @ts-nocheck 
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.8.0 (NJsonSchema v11.0.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import {ApiClientConfig} from "app/modules/common/api/ApiClientConfig";
import {AuthorizedApiBase} from "app/modules/common/api/AuthorizedApiBase";import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import moment from 'moment';

export interface IDataProviderClient {
    getUserData(): Promise<UserInfo>;
}

export class DataProviderClient extends AuthorizedApiBase implements IDataProviderClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiClientConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getUserData(signal?: AbortSignal): Promise<UserInfo> {
        let url_ = this.baseUrl + "/organization/DataProvider/GetUserData";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserData(_response);
        });
    }

    protected processGetUserData(response: AxiosResponse): Promise<UserInfo> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserInfo.fromJS(resultData200);
            return Promise.resolve<UserInfo>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserInfo>(null as any);
    }
}

export interface IOrganizationClient {
    deactivateOrganization(): Promise<void>;
    getOrganizationDetails(): Promise<OrganizationDetailsModel>;
}

export class OrganizationClient extends AuthorizedApiBase implements IOrganizationClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiClientConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    deactivateOrganization(signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/organization/Organization/DeactivateOrganization";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeactivateOrganization(_response);
        });
    }

    protected processDeactivateOrganization(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getOrganizationDetails(signal?: AbortSignal): Promise<OrganizationDetailsModel> {
        let url_ = this.baseUrl + "/organization/Organization/GetOrganizationDetails";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrganizationDetails(_response);
        });
    }

    protected processGetOrganizationDetails(response: AxiosResponse): Promise<OrganizationDetailsModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrganizationDetailsModel.fromJS(resultData200);
            return Promise.resolve<OrganizationDetailsModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrganizationDetailsModel>(null as any);
    }
}

export interface ITenantClient {
    getTenants(param: DataListGetParamsOfTenantListFilters | null): Promise<DataListResultOfTenantListModel>;
    getTenantsShortList(): Promise<NamedValueLong[]>;
    getUSDOTInfo(id: number): Promise<USDOTInfo>;
    createTenant(id: number): Promise<void>;
}

export class TenantClient extends AuthorizedApiBase implements ITenantClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiClientConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getTenants(param: DataListGetParamsOfTenantListFilters | null, signal?: AbortSignal): Promise<DataListResultOfTenantListModel> {
        let url_ = this.baseUrl + "/organization/Tenant/GetTenants";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(param);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTenants(_response);
        });
    }

    protected processGetTenants(response: AxiosResponse): Promise<DataListResultOfTenantListModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DataListResultOfTenantListModel.fromJS(resultData200);
            return Promise.resolve<DataListResultOfTenantListModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataListResultOfTenantListModel>(null as any);
    }

    getTenantsShortList(signal?: AbortSignal): Promise<NamedValueLong[]> {
        let url_ = this.baseUrl + "/organization/Tenant/GetTenantsShortList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTenantsShortList(_response);
        });
    }

    protected processGetTenantsShortList(response: AxiosResponse): Promise<NamedValueLong[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NamedValueLong.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<NamedValueLong[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NamedValueLong[]>(null as any);
    }

    getUSDOTInfo(id: number, signal?: AbortSignal): Promise<USDOTInfo> {
        let url_ = this.baseUrl + "/organization/Tenant/GetUSDOTInfo/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUSDOTInfo(_response);
        });
    }

    protected processGetUSDOTInfo(response: AxiosResponse): Promise<USDOTInfo> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = USDOTInfo.fromJS(resultData200);
            return Promise.resolve<USDOTInfo>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<USDOTInfo>(null as any);
    }

    createTenant(id: number, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/organization/Tenant/CreateTenant/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateTenant(_response);
        });
    }

    protected processCreateTenant(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IUserClient {
    getUsers(param: DataListGetParamsOfUserListFilters | null): Promise<DataListResultOfUserListModel>;
    getRoles(param: DataListGetParamsOfRoleListFilters | null): Promise<DataListResultOfRoleListModel>;
    getOrganizationUser(userId: string | null | undefined): Promise<UserListModel>;
    createOrganizationUser(model: NewOrganizationUserModel | null): Promise<void>;
    updateOrganizationUserFullName(model: OrganizationUserEditFullNameModel | null): Promise<void>;
    updateOrganizationUserEmail(model: OrganizationUserEditEmailModel | null): Promise<void>;
    updateOrganizationUserPhone(model: OrganizationUserEditPhoneModel | null): Promise<void>;
    addRoleToUser(model: OrganizationTenantUserUpdateTenantRoleForTenantUserModel | null): Promise<void>;
    removeRoleFromUser(model: OrganizationTenantUserUpdateTenantRoleForTenantUserModel | null): Promise<void>;
    getUserRolesPerTenant(userId: string | null | undefined): Promise<UserTenantRoles[]>;
    updateUserRolesPerTenant(userId: string | null | undefined, roles: UserTenantRoles[] | null): Promise<void>;
    activateOrganizationUser(userId: string | null | undefined): Promise<void>;
    deactivateOrganizationUser(userId: string | null | undefined): Promise<void>;
    addClaimToOrganizationUser(model: OrganizationTenantUserUpdateUserClaimForTenantUserModel | null): Promise<void>;
    removeClaimToOrganizationUser(model: OrganizationTenantUserUpdateUserClaimForTenantUserModel | null): Promise<void>;
    getUserClaims(userId: string | null | undefined, tenantId: number | undefined): Promise<string[]>;
    getOrganizationRoles(): Promise<NamedValue[]>;
    createOrganizationRole(model: OrganizationTenantRoleNewModel | null): Promise<void>;
    removeOrganizationRole(model: OrganizationTenantRoleEditModel | null): Promise<void>;
    addClaimToOrganizationRole(model: OrganizationTenantRoleClaimEditModel | null): Promise<void>;
    updateOrganizationRoleClaims(model: OrganizationTenantRoleClaimEditModel | null): Promise<void>;
    removeClaimFromOrganizationRole(model: OrganizationTenantRoleClaimEditModel | null): Promise<void>;
    getRoleClaims(roleId: string | null | undefined): Promise<string[]>;
    getAllAvailableTenantClaims(): Promise<string[]>;
    getRoleDetails(roleId: string | null | undefined): Promise<OrganizationTenantRoleDetails>;
    updateOrganizationRoleName(model: OrganizationTenantRoleUpdateModel | null): Promise<void>;
}

export class UserClient extends AuthorizedApiBase implements IUserClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiClientConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getUsers(param: DataListGetParamsOfUserListFilters | null, signal?: AbortSignal): Promise<DataListResultOfUserListModel> {
        let url_ = this.baseUrl + "/organization/User/GetUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(param);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUsers(_response);
        });
    }

    protected processGetUsers(response: AxiosResponse): Promise<DataListResultOfUserListModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DataListResultOfUserListModel.fromJS(resultData200);
            return Promise.resolve<DataListResultOfUserListModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataListResultOfUserListModel>(null as any);
    }

    getRoles(param: DataListGetParamsOfRoleListFilters | null, signal?: AbortSignal): Promise<DataListResultOfRoleListModel> {
        let url_ = this.baseUrl + "/organization/User/GetRoles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(param);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRoles(_response);
        });
    }

    protected processGetRoles(response: AxiosResponse): Promise<DataListResultOfRoleListModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DataListResultOfRoleListModel.fromJS(resultData200);
            return Promise.resolve<DataListResultOfRoleListModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataListResultOfRoleListModel>(null as any);
    }

    getOrganizationUser(userId: string | null | undefined, signal?: AbortSignal): Promise<UserListModel> {
        let url_ = this.baseUrl + "/organization/User/GetOrganizationUser?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrganizationUser(_response);
        });
    }

    protected processGetOrganizationUser(response: AxiosResponse): Promise<UserListModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserListModel.fromJS(resultData200);
            return Promise.resolve<UserListModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserListModel>(null as any);
    }

    createOrganizationUser(model: NewOrganizationUserModel | null, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/organization/User/CreateOrganizationUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrganizationUser(_response);
        });
    }

    protected processCreateOrganizationUser(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    updateOrganizationUserFullName(model: OrganizationUserEditFullNameModel | null, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/organization/User/UpdateOrganizationUserFullName";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateOrganizationUserFullName(_response);
        });
    }

    protected processUpdateOrganizationUserFullName(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    updateOrganizationUserEmail(model: OrganizationUserEditEmailModel | null, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/organization/User/UpdateOrganizationUserEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateOrganizationUserEmail(_response);
        });
    }

    protected processUpdateOrganizationUserEmail(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    updateOrganizationUserPhone(model: OrganizationUserEditPhoneModel | null, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/organization/User/UpdateOrganizationUserPhone";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateOrganizationUserPhone(_response);
        });
    }

    protected processUpdateOrganizationUserPhone(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    addRoleToUser(model: OrganizationTenantUserUpdateTenantRoleForTenantUserModel | null, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/organization/User/AddRoleToUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddRoleToUser(_response);
        });
    }

    protected processAddRoleToUser(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    removeRoleFromUser(model: OrganizationTenantUserUpdateTenantRoleForTenantUserModel | null, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/organization/User/RemoveRoleFromUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveRoleFromUser(_response);
        });
    }

    protected processRemoveRoleFromUser(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getUserRolesPerTenant(userId: string | null | undefined, signal?: AbortSignal): Promise<UserTenantRoles[]> {
        let url_ = this.baseUrl + "/organization/User/GetUserRolesPerTenant?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserRolesPerTenant(_response);
        });
    }

    protected processGetUserRolesPerTenant(response: AxiosResponse): Promise<UserTenantRoles[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserTenantRoles.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<UserTenantRoles[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserTenantRoles[]>(null as any);
    }

    updateUserRolesPerTenant(userId: string | null | undefined, roles: UserTenantRoles[] | null, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/organization/User/UpdateUserRolesPerTenant?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(roles);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateUserRolesPerTenant(_response);
        });
    }

    protected processUpdateUserRolesPerTenant(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    activateOrganizationUser(userId: string | null | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/organization/User/ActivateOrganizationUser?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processActivateOrganizationUser(_response);
        });
    }

    protected processActivateOrganizationUser(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    deactivateOrganizationUser(userId: string | null | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/organization/User/DeactivateOrganizationUser?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeactivateOrganizationUser(_response);
        });
    }

    protected processDeactivateOrganizationUser(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    addClaimToOrganizationUser(model: OrganizationTenantUserUpdateUserClaimForTenantUserModel | null, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/organization/User/AddClaimToOrganizationUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddClaimToOrganizationUser(_response);
        });
    }

    protected processAddClaimToOrganizationUser(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    removeClaimToOrganizationUser(model: OrganizationTenantUserUpdateUserClaimForTenantUserModel | null, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/organization/User/RemoveClaimToOrganizationUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveClaimToOrganizationUser(_response);
        });
    }

    protected processRemoveClaimToOrganizationUser(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getUserClaims(userId: string | null | undefined, tenantId: number | undefined, signal?: AbortSignal): Promise<string[]> {
        let url_ = this.baseUrl + "/organization/User/GetUserClaims?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserClaims(_response);
        });
    }

    protected processGetUserClaims(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    getOrganizationRoles(signal?: AbortSignal): Promise<NamedValue[]> {
        let url_ = this.baseUrl + "/organization/User/GetOrganizationRoles";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrganizationRoles(_response);
        });
    }

    protected processGetOrganizationRoles(response: AxiosResponse): Promise<NamedValue[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NamedValue.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<NamedValue[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NamedValue[]>(null as any);
    }

    createOrganizationRole(model: OrganizationTenantRoleNewModel | null, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/organization/User/CreateOrganizationRole";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrganizationRole(_response);
        });
    }

    protected processCreateOrganizationRole(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    removeOrganizationRole(model: OrganizationTenantRoleEditModel | null, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/organization/User/RemoveOrganizationRole";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveOrganizationRole(_response);
        });
    }

    protected processRemoveOrganizationRole(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    addClaimToOrganizationRole(model: OrganizationTenantRoleClaimEditModel | null, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/organization/User/AddClaimToOrganizationRole";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddClaimToOrganizationRole(_response);
        });
    }

    protected processAddClaimToOrganizationRole(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    updateOrganizationRoleClaims(model: OrganizationTenantRoleClaimEditModel | null, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/organization/User/UpdateOrganizationRoleClaims";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateOrganizationRoleClaims(_response);
        });
    }

    protected processUpdateOrganizationRoleClaims(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    removeClaimFromOrganizationRole(model: OrganizationTenantRoleClaimEditModel | null, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/organization/User/RemoveClaimFromOrganizationRole";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveClaimFromOrganizationRole(_response);
        });
    }

    protected processRemoveClaimFromOrganizationRole(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getRoleClaims(roleId: string | null | undefined, signal?: AbortSignal): Promise<string[]> {
        let url_ = this.baseUrl + "/organization/User/GetRoleClaims?";
        if (roleId !== undefined && roleId !== null)
            url_ += "roleId=" + encodeURIComponent("" + roleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRoleClaims(_response);
        });
    }

    protected processGetRoleClaims(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    getAllAvailableTenantClaims(signal?: AbortSignal): Promise<string[]> {
        let url_ = this.baseUrl + "/organization/User/GetAllAvailableTenantClaims";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllAvailableTenantClaims(_response);
        });
    }

    protected processGetAllAvailableTenantClaims(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    getRoleDetails(roleId: string | null | undefined, signal?: AbortSignal): Promise<OrganizationTenantRoleDetails> {
        let url_ = this.baseUrl + "/organization/User/GetRoleDetails?";
        if (roleId !== undefined && roleId !== null)
            url_ += "roleId=" + encodeURIComponent("" + roleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRoleDetails(_response);
        });
    }

    protected processGetRoleDetails(response: AxiosResponse): Promise<OrganizationTenantRoleDetails> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrganizationTenantRoleDetails.fromJS(resultData200);
            return Promise.resolve<OrganizationTenantRoleDetails>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrganizationTenantRoleDetails>(null as any);
    }

    updateOrganizationRoleName(model: OrganizationTenantRoleUpdateModel | null, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/organization/User/UpdateOrganizationRoleName";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateOrganizationRoleName(_response);
        });
    }

    protected processUpdateOrganizationRoleName(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class UserInfo implements IUserInfo {
    fullName?: string | undefined;
    userEmail?: string | undefined;
    isAdmin?: boolean;
    userType?: UserType;
    claims?: TenantClaims[] | undefined;
    adminClaims?: InternalClaims[] | undefined;
    tenantId?: number | undefined;
    pusherSettings?: PusherSettings | undefined;
    tenants?: NamedValueLong[] | undefined;

    constructor(data?: IUserInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["FullName"];
            this.userEmail = _data["UserEmail"];
            this.isAdmin = _data["IsAdmin"];
            this.userType = _data["UserType"];
            if (Array.isArray(_data["Claims"])) {
                this.claims = [] as any;
                for (let item of _data["Claims"])
                    this.claims!.push(item);
            }
            if (Array.isArray(_data["AdminClaims"])) {
                this.adminClaims = [] as any;
                for (let item of _data["AdminClaims"])
                    this.adminClaims!.push(item);
            }
            this.tenantId = _data["TenantId"];
            this.pusherSettings = _data["PusherSettings"] ? PusherSettings.fromJS(_data["PusherSettings"]) : <any>undefined;
            if (Array.isArray(_data["Tenants"])) {
                this.tenants = [] as any;
                for (let item of _data["Tenants"])
                    this.tenants!.push(NamedValueLong.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserInfo {
        data = typeof data === 'object' ? data : {};
        let result = new UserInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["FullName"] = this.fullName;
        data["UserEmail"] = this.userEmail;
        data["IsAdmin"] = this.isAdmin;
        data["UserType"] = this.userType;
        if (Array.isArray(this.claims)) {
            data["Claims"] = [];
            for (let item of this.claims)
                data["Claims"].push(item);
        }
        if (Array.isArray(this.adminClaims)) {
            data["AdminClaims"] = [];
            for (let item of this.adminClaims)
                data["AdminClaims"].push(item);
        }
        data["TenantId"] = this.tenantId;
        data["PusherSettings"] = this.pusherSettings ? this.pusherSettings.toJSON() : <any>undefined;
        if (Array.isArray(this.tenants)) {
            data["Tenants"] = [];
            for (let item of this.tenants)
                data["Tenants"].push(item.toJSON());
        }
        return data;
    }

    clone(): UserInfo {
        const json = this.toJSON();
        let result = new UserInfo();
        result.init(json);
        return result;
    }
}

export interface IUserInfo {
    fullName?: string | undefined;
    userEmail?: string | undefined;
    isAdmin?: boolean;
    userType?: UserType;
    claims?: TenantClaims[] | undefined;
    adminClaims?: InternalClaims[] | undefined;
    tenantId?: number | undefined;
    pusherSettings?: PusherSettings | undefined;
    tenants?: NamedValueLong[] | undefined;
}

/** 1 = Internal 2 = Tenant */
export enum UserType {
    Internal = 1,
    Tenant = 2,
}

/** 0 = FullAccess 1 = OrganizationAdmin 2 = UsersListView 3 = UsersEdit 4 = RoleListView 5 = RoleEdit 6 = TenantListView 7 = DriverListView 8 = DriverEdit 9 = CarrierListView 10 = CarrierEdit 11 = IntegrationListView 12 = IntegrationEdit 13 = IntegrationUserSettingsEdit 14 = IntegrationUserSettingsView 15 = VehicleListView 16 = VehicleEdit 17 = OrderTaskEdit 18 = OrderTaskView 19 = EditVehicleAvailability 20 = DeleteFile 21 = TenantNew 22 = CompanyUser 23 = SettingsEditView 24 = RadarView 25 = BidListView 26 = BidWon 27 = BidForceWon 28 = BidReject 29 = BidCreate 30 = OrderListView 31 = OrderEdit 32 = OrderVehicle 33 = OrderDrivers 34 = OrderNew 35 = OrderDraft 36 = OrderReady 37 = OrderOnHold 38 = OrderProgress 39 = OrderCancel 40 = OrderComplete 41 = OrderClose 42 = OrderNotification 43 = CustomerEdit 44 = ContactEdit 45 = TelegramChannelEdit 46 = AccountingInvoicing 47 = AccountingPayments 48 = AccountingAdmin 49 = AccountingSummary 50 = TrackingDeviceEdit 51 = OrderQuoteListView 52 = OrderQuoteEdit 53 = OwnerAccountEdit 54 = OwnerAccountListView 55 = AccountPayout 56 = AccountPayoutAdmin 57 = MobileLogView 58 = Inbox 59 = RateSettingsEdit */
export enum TenantClaims {
    FullAccess = 0,
    OrganizationAdmin = 1,
    UsersListView = 2,
    UsersEdit = 3,
    RoleListView = 4,
    RoleEdit = 5,
    TenantListView = 6,
    DriverListView = 7,
    DriverEdit = 8,
    CarrierListView = 9,
    CarrierEdit = 10,
    IntegrationListView = 11,
    IntegrationEdit = 12,
    IntegrationUserSettingsEdit = 13,
    IntegrationUserSettingsView = 14,
    VehicleListView = 15,
    VehicleEdit = 16,
    OrderTaskEdit = 17,
    OrderTaskView = 18,
    EditVehicleAvailability = 19,
    DeleteFile = 20,
    TenantNew = 21,
    CompanyUser = 22,
    SettingsEditView = 23,
    RadarView = 24,
    BidListView = 25,
    BidWon = 26,
    BidForceWon = 27,
    BidReject = 28,
    BidCreate = 29,
    OrderListView = 30,
    OrderEdit = 31,
    OrderVehicle = 32,
    OrderDrivers = 33,
    OrderNew = 34,
    OrderDraft = 35,
    OrderReady = 36,
    OrderOnHold = 37,
    OrderProgress = 38,
    OrderCancel = 39,
    OrderComplete = 40,
    OrderClose = 41,
    OrderNotification = 42,
    CustomerEdit = 43,
    ContactEdit = 44,
    TelegramChannelEdit = 45,
    AccountingInvoicing = 46,
    AccountingPayments = 47,
    AccountingAdmin = 48,
    AccountingSummary = 49,
    TrackingDeviceEdit = 50,
    OrderQuoteListView = 51,
    OrderQuoteEdit = 52,
    OwnerAccountEdit = 53,
    OwnerAccountListView = 54,
    AccountPayout = 55,
    AccountPayoutAdmin = 56,
    MobileLogView = 57,
    Inbox = 58,
    RateSettingsEdit = 59,
}

/** 0 = FullAccess 1 = HangfireDashboard */
export enum InternalClaims {
    FullAccess = 0,
    HangfireDashboard = 1,
}

export class PusherSettings implements IPusherSettings {
    cluster?: string | undefined;
    appKey?: string | undefined;
    pusherNamespace?: string | undefined;
    channelAuthorization?: string | undefined;

    constructor(data?: IPusherSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cluster = _data["Cluster"];
            this.appKey = _data["AppKey"];
            this.pusherNamespace = _data["PusherNamespace"];
            this.channelAuthorization = _data["ChannelAuthorization"];
        }
    }

    static fromJS(data: any): PusherSettings {
        data = typeof data === 'object' ? data : {};
        let result = new PusherSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Cluster"] = this.cluster;
        data["AppKey"] = this.appKey;
        data["PusherNamespace"] = this.pusherNamespace;
        data["ChannelAuthorization"] = this.channelAuthorization;
        return data;
    }

    clone(): PusherSettings {
        const json = this.toJSON();
        let result = new PusherSettings();
        result.init(json);
        return result;
    }
}

export interface IPusherSettings {
    cluster?: string | undefined;
    appKey?: string | undefined;
    pusherNamespace?: string | undefined;
    channelAuthorization?: string | undefined;
}

export class NamedValueLong implements INamedValueLong {
    id?: number;
    name?: string | undefined;

    constructor(data?: INamedValueLong) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
        }
    }

    static fromJS(data: any): NamedValueLong {
        data = typeof data === 'object' ? data : {};
        let result = new NamedValueLong();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        return data;
    }

    clone(): NamedValueLong {
        const json = this.toJSON();
        let result = new NamedValueLong();
        result.init(json);
        return result;
    }
}

export interface INamedValueLong {
    id?: number;
    name?: string | undefined;
}

export class OrganizationListModel implements IOrganizationListModel {
    id?: number;
    name?: string | undefined;
    active?: boolean;
    createdAt?: moment.Moment;
    tenants?: number;

    constructor(data?: IOrganizationListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.active = _data["Active"];
            this.createdAt = _data["CreatedAt"] ? moment(_data["CreatedAt"].toString()) : <any>undefined;
            this.tenants = _data["Tenants"];
        }
    }

    static fromJS(data: any): OrganizationListModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["Active"] = this.active;
        data["CreatedAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["Tenants"] = this.tenants;
        return data;
    }

    clone(): OrganizationListModel {
        const json = this.toJSON();
        let result = new OrganizationListModel();
        result.init(json);
        return result;
    }
}

export interface IOrganizationListModel {
    id?: number;
    name?: string | undefined;
    active?: boolean;
    createdAt?: moment.Moment;
    tenants?: number;
}

export class OrganizationDetailsModel extends OrganizationListModel implements IOrganizationDetailsModel {

    constructor(data?: IOrganizationDetailsModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): OrganizationDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationDetailsModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): OrganizationDetailsModel {
        const json = this.toJSON();
        let result = new OrganizationDetailsModel();
        result.init(json);
        return result;
    }
}

export interface IOrganizationDetailsModel extends IOrganizationListModel {
}

export class DataListResultOfTenantListModel implements IDataListResultOfTenantListModel {
    items?: TenantListModel[] | undefined;
    count?: number;

    constructor(data?: IDataListResultOfTenantListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(TenantListModel.fromJS(item));
            }
            this.count = _data["Count"];
        }
    }

    static fromJS(data: any): DataListResultOfTenantListModel {
        data = typeof data === 'object' ? data : {};
        let result = new DataListResultOfTenantListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item.toJSON());
        }
        data["Count"] = this.count;
        return data;
    }

    clone(): DataListResultOfTenantListModel {
        const json = this.toJSON();
        let result = new DataListResultOfTenantListModel();
        result.init(json);
        return result;
    }
}

export interface IDataListResultOfTenantListModel {
    items?: TenantListModel[] | undefined;
    count?: number;
}

export class TenantListModel implements ITenantListModel {
    id?: number;
    name?: string | undefined;
    status?: TenantStatus;
    uSDOT?: number;
    eIN?: number;
    address?: Address | undefined;
    createdAt?: moment.Moment;
    isMaintenance?: boolean;

    constructor(data?: ITenantListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.status = _data["Status"];
            this.uSDOT = _data["USDOT"];
            this.eIN = _data["EIN"];
            this.address = _data["Address"] ? Address.fromJS(_data["Address"]) : <any>undefined;
            this.createdAt = _data["CreatedAt"] ? moment(_data["CreatedAt"].toString()) : <any>undefined;
            this.isMaintenance = _data["IsMaintenance"];
        }
    }

    static fromJS(data: any): TenantListModel {
        data = typeof data === 'object' ? data : {};
        let result = new TenantListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["Status"] = this.status;
        data["USDOT"] = this.uSDOT;
        data["EIN"] = this.eIN;
        data["Address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["CreatedAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["IsMaintenance"] = this.isMaintenance;
        return data;
    }

    clone(): TenantListModel {
        const json = this.toJSON();
        let result = new TenantListModel();
        result.init(json);
        return result;
    }
}

export interface ITenantListModel {
    id?: number;
    name?: string | undefined;
    status?: TenantStatus;
    uSDOT?: number;
    eIN?: number;
    address?: Address | undefined;
    createdAt?: moment.Moment;
    isMaintenance?: boolean;
}

/** 1 = Pending 2 = Created 3 = Live 4 = Suspended 5 = Deactivated */
export enum TenantStatus {
    Pending = 1,
    Created = 2,
    Live = 3,
    Suspended = 4,
    Deactivated = 5,
}

export class Address implements IAddress {
    street?: string | undefined;
    street2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zipcode?: string | undefined;
    country?: string | undefined;

    constructor(data?: IAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.street = _data["Street"];
            this.street2 = _data["Street2"];
            this.city = _data["City"];
            this.state = _data["State"];
            this.zipcode = _data["Zipcode"];
            this.country = _data["Country"];
        }
    }

    static fromJS(data: any): Address {
        data = typeof data === 'object' ? data : {};
        let result = new Address();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Street"] = this.street;
        data["Street2"] = this.street2;
        data["City"] = this.city;
        data["State"] = this.state;
        data["Zipcode"] = this.zipcode;
        data["Country"] = this.country;
        return data;
    }

    clone(): Address {
        const json = this.toJSON();
        let result = new Address();
        result.init(json);
        return result;
    }
}

export interface IAddress {
    street?: string | undefined;
    street2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zipcode?: string | undefined;
    country?: string | undefined;
}

export class DataListGetParamsOfTenantListFilters implements IDataListGetParamsOfTenantListFilters {
    filter?: TenantListFilters | undefined;
    pageSize?: number;
    offset?: number;

    constructor(data?: IDataListGetParamsOfTenantListFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["Filter"] ? TenantListFilters.fromJS(_data["Filter"]) : <any>undefined;
            this.pageSize = _data["PageSize"];
            this.offset = _data["Offset"];
        }
    }

    static fromJS(data: any): DataListGetParamsOfTenantListFilters {
        data = typeof data === 'object' ? data : {};
        let result = new DataListGetParamsOfTenantListFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        data["PageSize"] = this.pageSize;
        data["Offset"] = this.offset;
        return data;
    }

    clone(): DataListGetParamsOfTenantListFilters {
        const json = this.toJSON();
        let result = new DataListGetParamsOfTenantListFilters();
        result.init(json);
        return result;
    }
}

export interface IDataListGetParamsOfTenantListFilters {
    filter?: TenantListFilters | undefined;
    pageSize?: number;
    offset?: number;
}

export class TenantListFilters implements ITenantListFilters {
    search?: string | undefined;

    constructor(data?: ITenantListFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.search = _data["Search"];
        }
    }

    static fromJS(data: any): TenantListFilters {
        data = typeof data === 'object' ? data : {};
        let result = new TenantListFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Search"] = this.search;
        return data;
    }

    clone(): TenantListFilters {
        const json = this.toJSON();
        let result = new TenantListFilters();
        result.init(json);
        return result;
    }
}

export interface ITenantListFilters {
    search?: string | undefined;
}

export class USDOTInfo implements IUSDOTInfo {
    carrier?: USDOTInfoCarrier | undefined;

    constructor(data?: IUSDOTInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.carrier = _data["Carrier"] ? USDOTInfoCarrier.fromJS(_data["Carrier"]) : <any>undefined;
        }
    }

    static fromJS(data: any): USDOTInfo {
        data = typeof data === 'object' ? data : {};
        let result = new USDOTInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Carrier"] = this.carrier ? this.carrier.toJSON() : <any>undefined;
        return data;
    }

    clone(): USDOTInfo {
        const json = this.toJSON();
        let result = new USDOTInfo();
        result.init(json);
        return result;
    }
}

export interface IUSDOTInfo {
    carrier?: USDOTInfoCarrier | undefined;
}

export class USDOTInfoCarrier implements IUSDOTInfoCarrier {
    allowedToOperate?: string | undefined;
    bipdInsuranceOnFile?: string | undefined;
    bipdRequiredAmount?: string | undefined;
    bondInsuranceOnFile?: string | undefined;
    bondInsuranceRequired?: string | undefined;
    brokerAuthorityStatus?: string | undefined;
    carrierOperation?: USDOTInfoCarrierOperation | undefined;
    censusTypeId?: USDOTInfoCensusType | undefined;
    commonAuthorityStatus?: string | undefined;
    contractAuthorityStatus?: string | undefined;
    isPassengerCarrier?: string | undefined;
    reviewDate?: string | undefined;
    reviewType?: string | undefined;
    safetyRating?: string | undefined;
    safetyRatingDate?: string | undefined;
    safetyReviewDate?: string | undefined;
    safetyReviewType?: string | undefined;
    snapshotDate?: string | undefined;
    dotNumber?: number;
    ein?: number;
    legalName?: string | undefined;
    dbaName?: string | undefined;
    phyCity?: string | undefined;
    phyCountry?: string | undefined;
    phyState?: string | undefined;
    phyStreet?: string | undefined;
    phyZipcode?: string | undefined;
    statusCode?: string | undefined;
    totalDrivers?: number;
    totalPowerUnits?: number;
    crashTotal?: number;
    driverInsp?: number;
    driverOosInsp?: number;
    driverOosRate?: number;
    driverOosRateNationalAverage?: string | undefined;
    fatalCrash?: number;
    hazmatInsp?: number;
    hazmatOosRate?: number;
    hazmatOosRateNationalAverage?: string | undefined;
    injCrash?: number;
    towawayCrash?: number;
    vehicleInsp?: number;
    vehicleOosInsp?: number;
    vehicleOosRate?: number;
    vehicleOosRateNationalAverage?: string | undefined;

    constructor(data?: IUSDOTInfoCarrier) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allowedToOperate = _data["AllowedToOperate"];
            this.bipdInsuranceOnFile = _data["BipdInsuranceOnFile"];
            this.bipdRequiredAmount = _data["BipdRequiredAmount"];
            this.bondInsuranceOnFile = _data["BondInsuranceOnFile"];
            this.bondInsuranceRequired = _data["BondInsuranceRequired"];
            this.brokerAuthorityStatus = _data["BrokerAuthorityStatus"];
            this.carrierOperation = _data["CarrierOperation"] ? USDOTInfoCarrierOperation.fromJS(_data["CarrierOperation"]) : <any>undefined;
            this.censusTypeId = _data["CensusTypeId"] ? USDOTInfoCensusType.fromJS(_data["CensusTypeId"]) : <any>undefined;
            this.commonAuthorityStatus = _data["CommonAuthorityStatus"];
            this.contractAuthorityStatus = _data["ContractAuthorityStatus"];
            this.isPassengerCarrier = _data["IsPassengerCarrier"];
            this.reviewDate = _data["ReviewDate"];
            this.reviewType = _data["ReviewType"];
            this.safetyRating = _data["SafetyRating"];
            this.safetyRatingDate = _data["SafetyRatingDate"];
            this.safetyReviewDate = _data["SafetyReviewDate"];
            this.safetyReviewType = _data["SafetyReviewType"];
            this.snapshotDate = _data["SnapshotDate"];
            this.dotNumber = _data["DotNumber"];
            this.ein = _data["Ein"];
            this.legalName = _data["LegalName"];
            this.dbaName = _data["DbaName"];
            this.phyCity = _data["PhyCity"];
            this.phyCountry = _data["PhyCountry"];
            this.phyState = _data["PhyState"];
            this.phyStreet = _data["PhyStreet"];
            this.phyZipcode = _data["PhyZipcode"];
            this.statusCode = _data["StatusCode"];
            this.totalDrivers = _data["TotalDrivers"];
            this.totalPowerUnits = _data["TotalPowerUnits"];
            this.crashTotal = _data["CrashTotal"];
            this.driverInsp = _data["DriverInsp"];
            this.driverOosInsp = _data["DriverOosInsp"];
            this.driverOosRate = _data["DriverOosRate"];
            this.driverOosRateNationalAverage = _data["DriverOosRateNationalAverage"];
            this.fatalCrash = _data["FatalCrash"];
            this.hazmatInsp = _data["HazmatInsp"];
            this.hazmatOosRate = _data["HazmatOosRate"];
            this.hazmatOosRateNationalAverage = _data["HazmatOosRateNationalAverage"];
            this.injCrash = _data["InjCrash"];
            this.towawayCrash = _data["TowawayCrash"];
            this.vehicleInsp = _data["VehicleInsp"];
            this.vehicleOosInsp = _data["VehicleOosInsp"];
            this.vehicleOosRate = _data["VehicleOosRate"];
            this.vehicleOosRateNationalAverage = _data["VehicleOosRateNationalAverage"];
        }
    }

    static fromJS(data: any): USDOTInfoCarrier {
        data = typeof data === 'object' ? data : {};
        let result = new USDOTInfoCarrier();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AllowedToOperate"] = this.allowedToOperate;
        data["BipdInsuranceOnFile"] = this.bipdInsuranceOnFile;
        data["BipdRequiredAmount"] = this.bipdRequiredAmount;
        data["BondInsuranceOnFile"] = this.bondInsuranceOnFile;
        data["BondInsuranceRequired"] = this.bondInsuranceRequired;
        data["BrokerAuthorityStatus"] = this.brokerAuthorityStatus;
        data["CarrierOperation"] = this.carrierOperation ? this.carrierOperation.toJSON() : <any>undefined;
        data["CensusTypeId"] = this.censusTypeId ? this.censusTypeId.toJSON() : <any>undefined;
        data["CommonAuthorityStatus"] = this.commonAuthorityStatus;
        data["ContractAuthorityStatus"] = this.contractAuthorityStatus;
        data["IsPassengerCarrier"] = this.isPassengerCarrier;
        data["ReviewDate"] = this.reviewDate;
        data["ReviewType"] = this.reviewType;
        data["SafetyRating"] = this.safetyRating;
        data["SafetyRatingDate"] = this.safetyRatingDate;
        data["SafetyReviewDate"] = this.safetyReviewDate;
        data["SafetyReviewType"] = this.safetyReviewType;
        data["SnapshotDate"] = this.snapshotDate;
        data["DotNumber"] = this.dotNumber;
        data["Ein"] = this.ein;
        data["LegalName"] = this.legalName;
        data["DbaName"] = this.dbaName;
        data["PhyCity"] = this.phyCity;
        data["PhyCountry"] = this.phyCountry;
        data["PhyState"] = this.phyState;
        data["PhyStreet"] = this.phyStreet;
        data["PhyZipcode"] = this.phyZipcode;
        data["StatusCode"] = this.statusCode;
        data["TotalDrivers"] = this.totalDrivers;
        data["TotalPowerUnits"] = this.totalPowerUnits;
        data["CrashTotal"] = this.crashTotal;
        data["DriverInsp"] = this.driverInsp;
        data["DriverOosInsp"] = this.driverOosInsp;
        data["DriverOosRate"] = this.driverOosRate;
        data["DriverOosRateNationalAverage"] = this.driverOosRateNationalAverage;
        data["FatalCrash"] = this.fatalCrash;
        data["HazmatInsp"] = this.hazmatInsp;
        data["HazmatOosRate"] = this.hazmatOosRate;
        data["HazmatOosRateNationalAverage"] = this.hazmatOosRateNationalAverage;
        data["InjCrash"] = this.injCrash;
        data["TowawayCrash"] = this.towawayCrash;
        data["VehicleInsp"] = this.vehicleInsp;
        data["VehicleOosInsp"] = this.vehicleOosInsp;
        data["VehicleOosRate"] = this.vehicleOosRate;
        data["VehicleOosRateNationalAverage"] = this.vehicleOosRateNationalAverage;
        return data;
    }

    clone(): USDOTInfoCarrier {
        const json = this.toJSON();
        let result = new USDOTInfoCarrier();
        result.init(json);
        return result;
    }
}

export interface IUSDOTInfoCarrier {
    allowedToOperate?: string | undefined;
    bipdInsuranceOnFile?: string | undefined;
    bipdRequiredAmount?: string | undefined;
    bondInsuranceOnFile?: string | undefined;
    bondInsuranceRequired?: string | undefined;
    brokerAuthorityStatus?: string | undefined;
    carrierOperation?: USDOTInfoCarrierOperation | undefined;
    censusTypeId?: USDOTInfoCensusType | undefined;
    commonAuthorityStatus?: string | undefined;
    contractAuthorityStatus?: string | undefined;
    isPassengerCarrier?: string | undefined;
    reviewDate?: string | undefined;
    reviewType?: string | undefined;
    safetyRating?: string | undefined;
    safetyRatingDate?: string | undefined;
    safetyReviewDate?: string | undefined;
    safetyReviewType?: string | undefined;
    snapshotDate?: string | undefined;
    dotNumber?: number;
    ein?: number;
    legalName?: string | undefined;
    dbaName?: string | undefined;
    phyCity?: string | undefined;
    phyCountry?: string | undefined;
    phyState?: string | undefined;
    phyStreet?: string | undefined;
    phyZipcode?: string | undefined;
    statusCode?: string | undefined;
    totalDrivers?: number;
    totalPowerUnits?: number;
    crashTotal?: number;
    driverInsp?: number;
    driverOosInsp?: number;
    driverOosRate?: number;
    driverOosRateNationalAverage?: string | undefined;
    fatalCrash?: number;
    hazmatInsp?: number;
    hazmatOosRate?: number;
    hazmatOosRateNationalAverage?: string | undefined;
    injCrash?: number;
    towawayCrash?: number;
    vehicleInsp?: number;
    vehicleOosInsp?: number;
    vehicleOosRate?: number;
    vehicleOosRateNationalAverage?: string | undefined;
}

export class USDOTInfoCarrierOperation implements IUSDOTInfoCarrierOperation {
    carrierOperationCode?: string | undefined;
    carrierOperationDesc?: string | undefined;

    constructor(data?: IUSDOTInfoCarrierOperation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.carrierOperationCode = _data["CarrierOperationCode"];
            this.carrierOperationDesc = _data["CarrierOperationDesc"];
        }
    }

    static fromJS(data: any): USDOTInfoCarrierOperation {
        data = typeof data === 'object' ? data : {};
        let result = new USDOTInfoCarrierOperation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CarrierOperationCode"] = this.carrierOperationCode;
        data["CarrierOperationDesc"] = this.carrierOperationDesc;
        return data;
    }

    clone(): USDOTInfoCarrierOperation {
        const json = this.toJSON();
        let result = new USDOTInfoCarrierOperation();
        result.init(json);
        return result;
    }
}

export interface IUSDOTInfoCarrierOperation {
    carrierOperationCode?: string | undefined;
    carrierOperationDesc?: string | undefined;
}

export class USDOTInfoCensusType implements IUSDOTInfoCensusType {
    censusType?: string | undefined;
    censusTypeDesc?: string | undefined;
    censusTypeId?: number;

    constructor(data?: IUSDOTInfoCensusType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.censusType = _data["CensusType"];
            this.censusTypeDesc = _data["CensusTypeDesc"];
            this.censusTypeId = _data["CensusTypeId"];
        }
    }

    static fromJS(data: any): USDOTInfoCensusType {
        data = typeof data === 'object' ? data : {};
        let result = new USDOTInfoCensusType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CensusType"] = this.censusType;
        data["CensusTypeDesc"] = this.censusTypeDesc;
        data["CensusTypeId"] = this.censusTypeId;
        return data;
    }

    clone(): USDOTInfoCensusType {
        const json = this.toJSON();
        let result = new USDOTInfoCensusType();
        result.init(json);
        return result;
    }
}

export interface IUSDOTInfoCensusType {
    censusType?: string | undefined;
    censusTypeDesc?: string | undefined;
    censusTypeId?: number;
}

export class DataListResultOfUserListModel implements IDataListResultOfUserListModel {
    items?: UserListModel[] | undefined;
    count?: number;

    constructor(data?: IDataListResultOfUserListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(UserListModel.fromJS(item));
            }
            this.count = _data["Count"];
        }
    }

    static fromJS(data: any): DataListResultOfUserListModel {
        data = typeof data === 'object' ? data : {};
        let result = new DataListResultOfUserListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item.toJSON());
        }
        data["Count"] = this.count;
        return data;
    }

    clone(): DataListResultOfUserListModel {
        const json = this.toJSON();
        let result = new DataListResultOfUserListModel();
        result.init(json);
        return result;
    }
}

export interface IDataListResultOfUserListModel {
    items?: UserListModel[] | undefined;
    count?: number;
}

export class UserListModel implements IUserListModel {
    id?: string | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    emailConfirmed?: boolean;
    userType?: UserType;
    organizationId?: number | undefined;
    organizationName?: string | undefined;
    createdAt?: moment.Moment;
    lockoutEnd?: moment.Moment | undefined;
    lastSignedIn?: moment.Moment | undefined;
    lastChangedPassword?: moment.Moment | undefined;
    phone?: string | undefined;

    constructor(data?: IUserListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.fullName = _data["FullName"];
            this.email = _data["Email"];
            this.emailConfirmed = _data["EmailConfirmed"];
            this.userType = _data["UserType"];
            this.organizationId = _data["OrganizationId"];
            this.organizationName = _data["OrganizationName"];
            this.createdAt = _data["CreatedAt"] ? moment(_data["CreatedAt"].toString()) : <any>undefined;
            this.lockoutEnd = _data["LockoutEnd"] ? moment(_data["LockoutEnd"].toString()) : <any>undefined;
            this.lastSignedIn = _data["LastSignedIn"] ? moment(_data["LastSignedIn"].toString()) : <any>undefined;
            this.lastChangedPassword = _data["LastChangedPassword"] ? moment(_data["LastChangedPassword"].toString()) : <any>undefined;
            this.phone = _data["Phone"];
        }
    }

    static fromJS(data: any): UserListModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["FullName"] = this.fullName;
        data["Email"] = this.email;
        data["EmailConfirmed"] = this.emailConfirmed;
        data["UserType"] = this.userType;
        data["OrganizationId"] = this.organizationId;
        data["OrganizationName"] = this.organizationName;
        data["CreatedAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["LockoutEnd"] = this.lockoutEnd ? this.lockoutEnd.toISOString() : <any>undefined;
        data["LastSignedIn"] = this.lastSignedIn ? this.lastSignedIn.toISOString() : <any>undefined;
        data["LastChangedPassword"] = this.lastChangedPassword ? this.lastChangedPassword.toISOString() : <any>undefined;
        data["Phone"] = this.phone;
        return data;
    }

    clone(): UserListModel {
        const json = this.toJSON();
        let result = new UserListModel();
        result.init(json);
        return result;
    }
}

export interface IUserListModel {
    id?: string | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    emailConfirmed?: boolean;
    userType?: UserType;
    organizationId?: number | undefined;
    organizationName?: string | undefined;
    createdAt?: moment.Moment;
    lockoutEnd?: moment.Moment | undefined;
    lastSignedIn?: moment.Moment | undefined;
    lastChangedPassword?: moment.Moment | undefined;
    phone?: string | undefined;
}

export class DataListGetParamsOfUserListFilters implements IDataListGetParamsOfUserListFilters {
    filter?: UserListFilters | undefined;
    pageSize?: number;
    offset?: number;

    constructor(data?: IDataListGetParamsOfUserListFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["Filter"] ? UserListFilters.fromJS(_data["Filter"]) : <any>undefined;
            this.pageSize = _data["PageSize"];
            this.offset = _data["Offset"];
        }
    }

    static fromJS(data: any): DataListGetParamsOfUserListFilters {
        data = typeof data === 'object' ? data : {};
        let result = new DataListGetParamsOfUserListFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        data["PageSize"] = this.pageSize;
        data["Offset"] = this.offset;
        return data;
    }

    clone(): DataListGetParamsOfUserListFilters {
        const json = this.toJSON();
        let result = new DataListGetParamsOfUserListFilters();
        result.init(json);
        return result;
    }
}

export interface IDataListGetParamsOfUserListFilters {
    filter?: UserListFilters | undefined;
    pageSize?: number;
    offset?: number;
}

export class UserListFilters implements IUserListFilters {
    search?: string | undefined;
    isLocked?: boolean | undefined;
    userType?: UserType | undefined;
    emailConfirmed?: boolean | undefined;

    constructor(data?: IUserListFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.search = _data["Search"];
            this.isLocked = _data["IsLocked"];
            this.userType = _data["UserType"];
            this.emailConfirmed = _data["EmailConfirmed"];
        }
    }

    static fromJS(data: any): UserListFilters {
        data = typeof data === 'object' ? data : {};
        let result = new UserListFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Search"] = this.search;
        data["IsLocked"] = this.isLocked;
        data["UserType"] = this.userType;
        data["EmailConfirmed"] = this.emailConfirmed;
        return data;
    }

    clone(): UserListFilters {
        const json = this.toJSON();
        let result = new UserListFilters();
        result.init(json);
        return result;
    }
}

export interface IUserListFilters {
    search?: string | undefined;
    isLocked?: boolean | undefined;
    userType?: UserType | undefined;
    emailConfirmed?: boolean | undefined;
}

export class DataListResultOfRoleListModel implements IDataListResultOfRoleListModel {
    items?: RoleListModel[] | undefined;
    count?: number;

    constructor(data?: IDataListResultOfRoleListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(RoleListModel.fromJS(item));
            }
            this.count = _data["Count"];
        }
    }

    static fromJS(data: any): DataListResultOfRoleListModel {
        data = typeof data === 'object' ? data : {};
        let result = new DataListResultOfRoleListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item.toJSON());
        }
        data["Count"] = this.count;
        return data;
    }

    clone(): DataListResultOfRoleListModel {
        const json = this.toJSON();
        let result = new DataListResultOfRoleListModel();
        result.init(json);
        return result;
    }
}

export interface IDataListResultOfRoleListModel {
    items?: RoleListModel[] | undefined;
    count?: number;
}

export class RoleListModel implements IRoleListModel {
    id?: string | undefined;
    name?: string | undefined;
    organizationId?: number | undefined;
    organizationName?: string | undefined;

    constructor(data?: IRoleListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.organizationId = _data["OrganizationId"];
            this.organizationName = _data["OrganizationName"];
        }
    }

    static fromJS(data: any): RoleListModel {
        data = typeof data === 'object' ? data : {};
        let result = new RoleListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["OrganizationId"] = this.organizationId;
        data["OrganizationName"] = this.organizationName;
        return data;
    }

    clone(): RoleListModel {
        const json = this.toJSON();
        let result = new RoleListModel();
        result.init(json);
        return result;
    }
}

export interface IRoleListModel {
    id?: string | undefined;
    name?: string | undefined;
    organizationId?: number | undefined;
    organizationName?: string | undefined;
}

export class DataListGetParamsOfRoleListFilters implements IDataListGetParamsOfRoleListFilters {
    filter?: RoleListFilters | undefined;
    pageSize?: number;
    offset?: number;

    constructor(data?: IDataListGetParamsOfRoleListFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["Filter"] ? RoleListFilters.fromJS(_data["Filter"]) : <any>undefined;
            this.pageSize = _data["PageSize"];
            this.offset = _data["Offset"];
        }
    }

    static fromJS(data: any): DataListGetParamsOfRoleListFilters {
        data = typeof data === 'object' ? data : {};
        let result = new DataListGetParamsOfRoleListFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        data["PageSize"] = this.pageSize;
        data["Offset"] = this.offset;
        return data;
    }

    clone(): DataListGetParamsOfRoleListFilters {
        const json = this.toJSON();
        let result = new DataListGetParamsOfRoleListFilters();
        result.init(json);
        return result;
    }
}

export interface IDataListGetParamsOfRoleListFilters {
    filter?: RoleListFilters | undefined;
    pageSize?: number;
    offset?: number;
}

export class RoleListFilters implements IRoleListFilters {
    search?: string | undefined;

    constructor(data?: IRoleListFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.search = _data["Search"];
        }
    }

    static fromJS(data: any): RoleListFilters {
        data = typeof data === 'object' ? data : {};
        let result = new RoleListFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Search"] = this.search;
        return data;
    }

    clone(): RoleListFilters {
        const json = this.toJSON();
        let result = new RoleListFilters();
        result.init(json);
        return result;
    }
}

export interface IRoleListFilters {
    search?: string | undefined;
}

export class NewOrganizationUserModel implements INewOrganizationUserModel {
    name?: string | undefined;
    email?: string | undefined;

    constructor(data?: INewOrganizationUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            this.email = _data["Email"];
        }
    }

    static fromJS(data: any): NewOrganizationUserModel {
        data = typeof data === 'object' ? data : {};
        let result = new NewOrganizationUserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["Email"] = this.email;
        return data;
    }

    clone(): NewOrganizationUserModel {
        const json = this.toJSON();
        let result = new NewOrganizationUserModel();
        result.init(json);
        return result;
    }
}

export interface INewOrganizationUserModel {
    name?: string | undefined;
    email?: string | undefined;
}

export abstract class OrganizationUserEditBaseModel implements IOrganizationUserEditBaseModel {
    userId?: string | undefined;

    constructor(data?: IOrganizationUserEditBaseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["UserId"];
        }
    }

    static fromJS(data: any): OrganizationUserEditBaseModel {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'OrganizationUserEditBaseModel' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UserId"] = this.userId;
        return data;
    }

    clone(): OrganizationUserEditBaseModel {
        throw new Error("The abstract class 'OrganizationUserEditBaseModel' cannot be instantiated.");
    }
}

export interface IOrganizationUserEditBaseModel {
    userId?: string | undefined;
}

export class OrganizationUserEditFullNameModel extends OrganizationUserEditBaseModel implements IOrganizationUserEditFullNameModel {
    fullName?: string | undefined;

    constructor(data?: IOrganizationUserEditFullNameModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.fullName = _data["FullName"];
        }
    }

    static override fromJS(data: any): OrganizationUserEditFullNameModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUserEditFullNameModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["FullName"] = this.fullName;
        super.toJSON(data);
        return data;
    }

    clone(): OrganizationUserEditFullNameModel {
        const json = this.toJSON();
        let result = new OrganizationUserEditFullNameModel();
        result.init(json);
        return result;
    }
}

export interface IOrganizationUserEditFullNameModel extends IOrganizationUserEditBaseModel {
    fullName?: string | undefined;
}

export class OrganizationUserEditEmailModel extends OrganizationUserEditBaseModel implements IOrganizationUserEditEmailModel {
    email?: string | undefined;

    constructor(data?: IOrganizationUserEditEmailModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.email = _data["Email"];
        }
    }

    static override fromJS(data: any): OrganizationUserEditEmailModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUserEditEmailModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Email"] = this.email;
        super.toJSON(data);
        return data;
    }

    clone(): OrganizationUserEditEmailModel {
        const json = this.toJSON();
        let result = new OrganizationUserEditEmailModel();
        result.init(json);
        return result;
    }
}

export interface IOrganizationUserEditEmailModel extends IOrganizationUserEditBaseModel {
    email?: string | undefined;
}

export class OrganizationUserEditPhoneModel extends OrganizationUserEditBaseModel implements IOrganizationUserEditPhoneModel {
    phone?: string | undefined;

    constructor(data?: IOrganizationUserEditPhoneModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.phone = _data["Phone"];
        }
    }

    static override fromJS(data: any): OrganizationUserEditPhoneModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUserEditPhoneModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Phone"] = this.phone;
        super.toJSON(data);
        return data;
    }

    clone(): OrganizationUserEditPhoneModel {
        const json = this.toJSON();
        let result = new OrganizationUserEditPhoneModel();
        result.init(json);
        return result;
    }
}

export interface IOrganizationUserEditPhoneModel extends IOrganizationUserEditBaseModel {
    phone?: string | undefined;
}

export abstract class OrganizationTenantUserEditBaseModel extends OrganizationUserEditBaseModel implements IOrganizationTenantUserEditBaseModel {
    tenantId?: number;

    constructor(data?: IOrganizationTenantUserEditBaseModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tenantId = _data["TenantId"];
        }
    }

    static override fromJS(data: any): OrganizationTenantUserEditBaseModel {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'OrganizationTenantUserEditBaseModel' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["TenantId"] = this.tenantId;
        super.toJSON(data);
        return data;
    }

    clone(): OrganizationTenantUserEditBaseModel {
        throw new Error("The abstract class 'OrganizationTenantUserEditBaseModel' cannot be instantiated.");
    }
}

export interface IOrganizationTenantUserEditBaseModel extends IOrganizationUserEditBaseModel {
    tenantId?: number;
}

export class OrganizationTenantUserUpdateTenantRoleForTenantUserModel extends OrganizationTenantUserEditBaseModel implements IOrganizationTenantUserUpdateTenantRoleForTenantUserModel {
    roleName?: string | undefined;

    constructor(data?: IOrganizationTenantUserUpdateTenantRoleForTenantUserModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.roleName = _data["RoleName"];
        }
    }

    static override fromJS(data: any): OrganizationTenantUserUpdateTenantRoleForTenantUserModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationTenantUserUpdateTenantRoleForTenantUserModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["RoleName"] = this.roleName;
        super.toJSON(data);
        return data;
    }

    clone(): OrganizationTenantUserUpdateTenantRoleForTenantUserModel {
        const json = this.toJSON();
        let result = new OrganizationTenantUserUpdateTenantRoleForTenantUserModel();
        result.init(json);
        return result;
    }
}

export interface IOrganizationTenantUserUpdateTenantRoleForTenantUserModel extends IOrganizationTenantUserEditBaseModel {
    roleName?: string | undefined;
}

export class UserTenantRoles implements IUserTenantRoles {
    tenantId?: number;
    roleIds?: string[] | undefined;

    constructor(data?: IUserTenantRoles) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["TenantId"];
            if (Array.isArray(_data["RoleIds"])) {
                this.roleIds = [] as any;
                for (let item of _data["RoleIds"])
                    this.roleIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UserTenantRoles {
        data = typeof data === 'object' ? data : {};
        let result = new UserTenantRoles();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["TenantId"] = this.tenantId;
        if (Array.isArray(this.roleIds)) {
            data["RoleIds"] = [];
            for (let item of this.roleIds)
                data["RoleIds"].push(item);
        }
        return data;
    }

    clone(): UserTenantRoles {
        const json = this.toJSON();
        let result = new UserTenantRoles();
        result.init(json);
        return result;
    }
}

export interface IUserTenantRoles {
    tenantId?: number;
    roleIds?: string[] | undefined;
}

export class OrganizationTenantUserUpdateUserClaimForTenantUserModel extends OrganizationTenantUserEditBaseModel implements IOrganizationTenantUserUpdateUserClaimForTenantUserModel {
    claims?: string[] | undefined;

    constructor(data?: IOrganizationTenantUserUpdateUserClaimForTenantUserModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["Claims"])) {
                this.claims = [] as any;
                for (let item of _data["Claims"])
                    this.claims!.push(item);
            }
        }
    }

    static override fromJS(data: any): OrganizationTenantUserUpdateUserClaimForTenantUserModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationTenantUserUpdateUserClaimForTenantUserModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.claims)) {
            data["Claims"] = [];
            for (let item of this.claims)
                data["Claims"].push(item);
        }
        super.toJSON(data);
        return data;
    }

    clone(): OrganizationTenantUserUpdateUserClaimForTenantUserModel {
        const json = this.toJSON();
        let result = new OrganizationTenantUserUpdateUserClaimForTenantUserModel();
        result.init(json);
        return result;
    }
}

export interface IOrganizationTenantUserUpdateUserClaimForTenantUserModel extends IOrganizationTenantUserEditBaseModel {
    claims?: string[] | undefined;
}

export class NamedValue implements INamedValue {
    id?: string | undefined;
    name?: string | undefined;

    constructor(data?: INamedValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
        }
    }

    static fromJS(data: any): NamedValue {
        data = typeof data === 'object' ? data : {};
        let result = new NamedValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        return data;
    }

    clone(): NamedValue {
        const json = this.toJSON();
        let result = new NamedValue();
        result.init(json);
        return result;
    }
}

export interface INamedValue {
    id?: string | undefined;
    name?: string | undefined;
}

export class OrganizationTenantRoleNewModel implements IOrganizationTenantRoleNewModel {
    roleName?: string | undefined;
    claims?: string[] | undefined;

    constructor(data?: IOrganizationTenantRoleNewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleName = _data["RoleName"];
            if (Array.isArray(_data["Claims"])) {
                this.claims = [] as any;
                for (let item of _data["Claims"])
                    this.claims!.push(item);
            }
        }
    }

    static fromJS(data: any): OrganizationTenantRoleNewModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationTenantRoleNewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["RoleName"] = this.roleName;
        if (Array.isArray(this.claims)) {
            data["Claims"] = [];
            for (let item of this.claims)
                data["Claims"].push(item);
        }
        return data;
    }

    clone(): OrganizationTenantRoleNewModel {
        const json = this.toJSON();
        let result = new OrganizationTenantRoleNewModel();
        result.init(json);
        return result;
    }
}

export interface IOrganizationTenantRoleNewModel {
    roleName?: string | undefined;
    claims?: string[] | undefined;
}

export class OrganizationTenantRoleEditModel implements IOrganizationTenantRoleEditModel {
    roleId?: string | undefined;

    constructor(data?: IOrganizationTenantRoleEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data["RoleId"];
        }
    }

    static fromJS(data: any): OrganizationTenantRoleEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationTenantRoleEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["RoleId"] = this.roleId;
        return data;
    }

    clone(): OrganizationTenantRoleEditModel {
        const json = this.toJSON();
        let result = new OrganizationTenantRoleEditModel();
        result.init(json);
        return result;
    }
}

export interface IOrganizationTenantRoleEditModel {
    roleId?: string | undefined;
}

export class OrganizationTenantRoleClaimEditModel extends OrganizationTenantRoleEditModel implements IOrganizationTenantRoleClaimEditModel {
    claims?: string[] | undefined;

    constructor(data?: IOrganizationTenantRoleClaimEditModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["Claims"])) {
                this.claims = [] as any;
                for (let item of _data["Claims"])
                    this.claims!.push(item);
            }
        }
    }

    static override fromJS(data: any): OrganizationTenantRoleClaimEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationTenantRoleClaimEditModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.claims)) {
            data["Claims"] = [];
            for (let item of this.claims)
                data["Claims"].push(item);
        }
        super.toJSON(data);
        return data;
    }

    clone(): OrganizationTenantRoleClaimEditModel {
        const json = this.toJSON();
        let result = new OrganizationTenantRoleClaimEditModel();
        result.init(json);
        return result;
    }
}

export interface IOrganizationTenantRoleClaimEditModel extends IOrganizationTenantRoleEditModel {
    claims?: string[] | undefined;
}

export class OrganizationTenantRoleDetails implements IOrganizationTenantRoleDetails {
    id?: string | undefined;
    name?: string | undefined;

    constructor(data?: IOrganizationTenantRoleDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
        }
    }

    static fromJS(data: any): OrganizationTenantRoleDetails {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationTenantRoleDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        return data;
    }

    clone(): OrganizationTenantRoleDetails {
        const json = this.toJSON();
        let result = new OrganizationTenantRoleDetails();
        result.init(json);
        return result;
    }
}

export interface IOrganizationTenantRoleDetails {
    id?: string | undefined;
    name?: string | undefined;
}

export class OrganizationTenantRoleUpdateModel implements IOrganizationTenantRoleUpdateModel {
    id?: string | undefined;
    name?: string | undefined;

    constructor(data?: IOrganizationTenantRoleUpdateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
        }
    }

    static fromJS(data: any): OrganizationTenantRoleUpdateModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationTenantRoleUpdateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        return data;
    }

    clone(): OrganizationTenantRoleUpdateModel {
        const json = this.toJSON();
        let result = new OrganizationTenantRoleUpdateModel();
        result.init(json);
        return result;
    }
}

export interface IOrganizationTenantRoleUpdateModel {
    id?: string | undefined;
    name?: string | undefined;
}

export class CodedExceptionApi extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isCodedExceptionApi = true;

    static isCodedExceptionApi(obj: any): obj is CodedExceptionApi {
        return obj.isCodedExceptionApi === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new CodedExceptionApi(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}